module.exports = __webpack_public_path__ + "img/preview-1.b8c6e272.webp";